import { Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { GlobalStyle } from "./styles/globalStyle";
import { ThemeProvider } from "styled-components";
import { getTheme, Themes } from "./styles/theme";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import About from "./pages/About";
import NftDetails from "./pages/NftDetails";
import Spotlights from "./pages/Spotlights";
import "./App.css";
import AiRankingPage from "./pages/AiRanking";
import CollectionDetails from "./pages/CollectionDetails";

// new pages
import Marketplace from "./newPages/Marketplace";
import Dashboard from "./newPages/Dashboard";
import Portfolio from "./pages/Portfolio";
import ScrollToTop from "./components/ScrollToTop";
import SearchResult from "./pages/SearchResult";
import Roadmap from "./pages/Roadmap";
import { RainbowKitProvider } from '@rainbow-me/rainbowkit';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import '@rainbow-me/rainbowkit/styles.css';
import { WagmiProvider, http, createStorage, cookieStorage } from 'wagmi'
import { sepolia, bscTestnet, blastSepolia } from 'wagmi/chains'
import { Chain, getDefaultConfig } from '@rainbow-me/rainbowkit'

import { WalletProvider } from "./utils/WalletContext";
import TermsAndConditions from "./newPages/Terms&Conditions/TermsConditions";
import PrivacyPolicy from "./newPages/PrivacyPolicies/PrivacyPolicy";
import CookieConsent from "./utils/CookiesContent";

function App() {
  const currentTheme = { ...getTheme(Themes.LIGHT), selected: Themes.LIGHT };
  const queryClient = new QueryClient();

  const projectId = process.env.REACT_APP_HASHPACK_PROJECT_ID;

  const supportedChains: Chain[] = [sepolia, bscTestnet, blastSepolia];

  const config = getDefaultConfig({
    appName: 'VYGA',
    projectId: projectId as any,
    chains: supportedChains as any,
    ssr: true,
    storage: createStorage({
    storage: cookieStorage,
    }),
    transports: supportedChains.reduce((obj, chain) => ({ ...obj, [chain.id]: http() }), {})
  });

  return (
    <WalletProvider>
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider>
    <ThemeProvider theme={currentTheme}>
      <GlobalStyle />
      <BrowserRouter>
      <ScrollToTop/>
        <Suspense fallback={"Loading....."}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route
              path="/collection-details/:id"
              element={<CollectionDetails />}
            />
            <Route path="/nft-details/:id" element={<NftDetails />} />
            <Route path="/about" element={<About />} />
            <Route path="/marketplace" element={<Marketplace />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/spotlights" element={<Spotlights />} />
            <Route path="/dashboard/:id" element={<Dashboard />} />
            <Route path="/ai-ranking" element={<AiRankingPage />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/search-results/:query" element={<SearchResult/>} />
            <Route path="/search-results" element={<SearchResult/>} />
            <Route path="/search-results/" element={<SearchResult/>} />
            <Route path="/roadmap" element={<Roadmap/>} />
            <Route path="/termsconditions" element={<TermsAndConditions/>} />
            <Route path="/privacypolicy" element={<PrivacyPolicy/>} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </ThemeProvider>
      </RainbowKitProvider>
    </QueryClientProvider>
  </WagmiProvider>
  <CookieConsent/>
  </WalletProvider>
  );
}

export default App;
